import saga from "@Saga";
import AppUserReducer from "@Store/AppUser/reducers";
import InvitesReducer from "@Store/Invites/reducers";
import MasterDataReducer from "@Store/MasterData/reducers";
import MatrixReducer from "@Store/Matrix/reducers";
import OrganizationsReducer from "@Store/Organizations/reducers";
import AppsReducer from "@Store/Apps/reducers";
import UsersReducer from "@Store/Users/reducers";
import TeamsReducer from "@Store/Team/reducer";
import UserUpdateRequestsReducer from "@Store/UserUpdateRequests/reducers";
import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import thunkMiddleware from "redux-thunk";
import AppReducer from "./App/reducers";
import snackbarReducer from "@Store/toast/reducer";

const sagaMiddleware = createSagaMiddleware({});

const store = configureStore({
  reducer: {
    app: AppReducer,
    appUser: AppUserReducer,
    organizations: OrganizationsReducer,
    apps: AppsReducer,
    masterData: MasterDataReducer,
    matrix: MatrixReducer,
    users: UsersReducer,
    invites: InvitesReducer,
    teams: TeamsReducer,
    userUpdateRequests: UserUpdateRequestsReducer,
    snackbar: snackbarReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(thunkMiddleware, sagaMiddleware),
});

sagaMiddleware.run(saga);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export const storeState = store.getState();

export default store;
